import React from 'react';
import './EmbedPlaceholder.css';

const EmbedPlaceholder = ({ userName }) => {
  return (
    <div className="embed-container">
      <iframe 
        src="https://chat.callme.ai/guest?orgId=895c4278-91b5-4401-bda3-88635b0df2a1&slotId=e6f7740e-b3b0-496e-918e-63b592bf044b"
        style={{ width: '100%', height: '100%', border: 'none' }}
        allow="camera;microphone;fullscreen;clipboard-write"
        referrerPolicy="origin"
        title="Vira AI Assistant"
      />
    </div>
  );
};

export default EmbedPlaceholder;